import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  Box, Drawer, AppBar, Toolbar, Typography, List, ListItemButton, ListItemIcon,
  ListItemText, IconButton, Divider, Avatar, Menu, MenuItem
} from '@mui/material';
import {
  Dashboard as DashboardIcon, Description, People, Email, Settings, History,
  Menu as MenuIcon, Logout, Link as LinkIcon, AccountCircle, Public, InsertChart, HowToReg, Palette
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { useBranding } from '../../contexts/BrandingContext';

var DRAWER_WIDTH = 260;

var navItems = [
  { label: 'Dashboard', icon: React.createElement(DashboardIcon), path: '/admin' },
  { label: 'Forms', icon: React.createElement(Description), path: '/admin/forms' },
  { label: 'Access Control', icon: React.createElement(People), path: '/admin/reviewers' },
  { label: 'Short URLs', icon: React.createElement(LinkIcon), path: '/admin/short-urls' },
  { label: 'Selection', icon: React.createElement(HowToReg), path: '/admin/selection' },
  { label: 'Dashboards', icon: React.createElement(InsertChart), path: '/admin/dashboards' },
  { label: 'Countries', icon: React.createElement(Public), path: '/admin/countries' },
  { label: 'Email Templates', icon: React.createElement(Email), path: '/admin/email-templates' },
  { label: 'Branding', icon: React.createElement(Palette), path: '/admin/branding' },
  { label: 'SMTP Settings', icon: React.createElement(Settings), path: '/admin/smtp' },
  { label: 'Audit Log', icon: React.createElement(History), path: '/admin/audit-log' },
  { label: 'Account Settings', icon: React.createElement(AccountCircle), path: '/admin/settings' },
];

export default function AdminLayout() {
  var auth = useAuth();
  var branding = useBranding();
  var navigate = useNavigate();
  var location = useLocation();
  var ms = useState(false);
  var mobileOpen = ms[0], setMobileOpen = ms[1];
  var as = useState(null);
  var anchorEl = as[0], setAnchorEl = as[1];

  var handleNav = function(path) {
    navigate(path);
    setMobileOpen(false);
  };

  var drawer = React.createElement(Box, null,
    React.createElement(Toolbar, { sx: { px: 2 } },
      React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1.5 } },
        React.createElement(Box, { sx: { width: 32, height: 32, borderRadius: 1, bgcolor: 'secondary.main',
          display: 'flex', alignItems: 'center', justifyContent: 'center' } },
          React.createElement(Typography, { variant: 'body2', sx: { color: 'white', fontWeight: 700 } }, 'OK')
        ),
        React.createElement(Box, null,
          React.createElement(Typography, { variant: 'subtitle2', sx: { fontWeight: 700, lineHeight: 1.2 } }, branding.portal_name),
          React.createElement(Typography, { variant: 'caption', color: 'text.secondary' }, branding.portal_tagline + ' Admin')
        )
      )
    ),
    React.createElement(Divider),
    React.createElement(List, { sx: { px: 1, pt: 1 } },
      navItems.map(function(item) {
        return React.createElement(ListItemButton, {
          key: item.path,
          onClick: function() { handleNav(item.path); },
          selected: location.pathname === item.path,
          sx: { borderRadius: 1, mb: 0.5,
            '&.Mui-selected': { bgcolor: 'primary.main', color: 'white',
            '& .MuiListItemIcon-root': { color: 'white' } } }
        },
          React.createElement(ListItemIcon, { sx: { minWidth: 40 } }, item.icon),
          React.createElement(ListItemText, {
            primary: item.label,
            primaryTypographyProps: { variant: 'body2', fontWeight: 500 }
          })
        );
      })
    )
  );

  return React.createElement(Box, { sx: { display: 'flex', minHeight: '100vh' } },
    React.createElement(AppBar, { position: 'fixed', sx: { zIndex: function(t) { return t.zIndex.drawer + 1; },
      bgcolor: 'white', color: 'text.primary', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' } },
      React.createElement(Toolbar, null,
        React.createElement(IconButton, { edge: 'start', onClick: function() { setMobileOpen(!mobileOpen); },
          sx: { mr: 2, display: { md: 'none' } } }, React.createElement(MenuIcon)),
        React.createElement(Typography, { variant: 'h6', sx: { flexGrow: 1 } }),
        React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 } },
          React.createElement(Typography, { variant: 'body2' }, auth.user && auth.user.name),
          React.createElement(IconButton, { onClick: function(e) { setAnchorEl(e.currentTarget); } },
            React.createElement(Avatar, { sx: { width: 32, height: 32, bgcolor: 'primary.main', fontSize: 14 } },
              auth.user && auth.user.name ? auth.user.name.charAt(0).toUpperCase() : '?')
          ),
          React.createElement(Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: function() { setAnchorEl(null); } },
            React.createElement(MenuItem, { onClick: function() { navigate('/reviewer'); setAnchorEl(null); } }, 'Reviewer View'),
            React.createElement(Divider),
            React.createElement(MenuItem, { onClick: function() { auth.logout(); navigate('/login'); } },
              React.createElement(Logout, { sx: { mr: 1, fontSize: 18 } }), ' Sign out')
          )
        )
      )
    ),
    React.createElement(Drawer, { variant: 'temporary', open: mobileOpen,
      onClose: function() { setMobileOpen(false); },
      sx: { display: { xs: 'block', md: 'none' }, '& .MuiDrawer-paper': { width: DRAWER_WIDTH } } }, drawer),
    React.createElement(Drawer, { variant: 'permanent',
      sx: { display: { xs: 'none', md: 'block' }, width: DRAWER_WIDTH,
        '& .MuiDrawer-paper': { width: DRAWER_WIDTH, boxSizing: 'border-box' } } }, drawer),
    React.createElement(Box, { component: 'main',
      sx: { flexGrow: 1, p: 3, mt: 8, bgcolor: 'background.default', minHeight: '100vh' } },
      React.createElement(Outlet)
    )
  );
}
